var classes = {"fullBleedExperience":"_4gOBl","fullBleedExperienceContentWrapper":"YNMGZ","fullBleedExperienceMediaWrapper":"Fpxzd","fullBleedExperienceImageAspectRatio":"_7rlg6","fullBleedExperienceTopMiddle":"-KaRl","fullBleedExperienceBottomMiddle":"qoCVW","fullBleedExperienceContentHeading":"onj9l","fullBleedExperienceContentCopy":"BCiBH"};

export { classes as default };
